<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/staffing/info/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" class="demo-form-inline">
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="false" :type="'material2'" :ids.sync="yt.conditions.materialId" clearable></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('chanxian')">
            <el-select v-model="yt.conditions.equipmentId" :placeholder="$t('chanxian')" style="width: 50%;" clearable>
              <el-option v-for="item in equipmentData" :key="item.id" :label="item.sn + '/' + item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <template #buttonsL>
        <el-button
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w2');
            records = [];
          "
          type="primary"
          v-if="utils.checkPower('web_screen_printing_management_staff_allocation_create')"
        >
          {{ $t('xinzeng') }}
        </el-button>
      </template>

      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <template #caozuo="scope">
        <el-button size="mini" v-if="utils.checkPower('web_screen_printing_management_staff_allocation_update')" @click="yt.showEditDialog('bianji', scope.row, 'w2', beforeEdit)" type="text">
          {{ $t('bianji') }}
        </el-button>

        <el-button size="mini" v-if="utils.checkPower('web_screen_printing_management_staff_allocation_delete')" @click="yt.remove(scope.row, '/web/staffing/info/delete')" type="text">
          {{ $t('shanchu') }}
        </el-button>
      </template>
    </yi_curd_table>

    <el-dialog :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" append-to-body="append-to-body" :closed="close">
      <template v-if="yt.editObj.action === 'xinzeng'">
        <el-form label-width="120px" class="form" size="mini" :rules="rules">
          <el-form-item :label="$t('chanxian')" required>
            <el-select v-model="yt.editObj.equipmentId" :placeholder="$t('chanxian')" style="width: 50%;" clearable>
              <el-option v-for="item in equipmentData" :key="item.id" :label="item.sn + '/' + item.name" :value="item.id" />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('chanpinmingcheng')" required>
            <yi_data_select :multiple="false" :type="'material2'" :ids.sync="yt.editObj.materialId" clearable></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('shengchangongdanhao')" required>
            <el-select v-model="yt.editObj.woIdList" style="width: 50%;" multiple clearable :disabled="woFlag" @change="woListChange">
              <el-option v-for="wo in woList" :key="wo.id" :label="wo.no" :value="wo.id" />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('biaozhungongshi')">
            <el-input v-model="yt.editObj.workHours" style="width: 50%;" disabled />
          </el-form-item>

          <el-form-item :label="$t('jihuashuliang')">
            <el-input v-model="yt.editObj.planQty" style="width: 50%;" disabled />
          </el-form-item>

          <el-form-item :label="$t('shangjishijian')" required>
            <el-date-picker v-model="yt.editObj.upTime" type="datetime" placeholder="" clearable @change="timeChange" />
          </el-form-item>

          <el-form-item :label="$t('xiajishijian')" required>
            <el-date-picker v-model="yt.editObj.downTime" type="datetime" placeholder="" clearable />
          </el-form-item>

          <el-table :data="records" style="width: 100%; margin-top: 20px" border size="mini">
            <el-table-column type="index" width="50" :label="$t('xuhao')" />
            <el-table-column :label="$t('gongwei')" align="center">
              <template slot-scope="scope">
                <yi_dictionary_select type="SILK_SCREEN_PRINTING_STATION" :ids.sync="scope.row.station"></yi_dictionary_select>
              </template>
            </el-table-column>
            <el-table-column :label="$t('renyuan')" align="center">
              <template slot-scope="scope">
                <el-select v-model="scope.row.person" :placeholder="$t('qingxuanze')" size="mini" multiple filterable>
                  <el-option v-for="employ in employList" :key="employ.id" :label="employ.name" :value="employ.id" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column :label="$t('caozuo')" align="center">
              <template slot-scope="scope">
                <el-button type="text" style="color: red;" @click="removeRecord(scope.$index)">
                  {{ $t('shanchu') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div style="margin: 10px 0;">
            <el-link type="primary" @click="addRecord">+ {{ $t('xinzengyitiaojilu') }}</el-link>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close()">{{ $t('quxiao') }}</el-button>
          <el-button v-if="yt.editObj.action == 'xinzeng'" size="mini" :loading="yt.editObj.loading" @click="saveData()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action === 'bianji'">
        <el-form label-width="120px" class="form" size="mini">
          <el-form-item :label="$t('chanxian')" required>
            <el-select v-model="yt.editObj.equipmentId" :placeholder="$t('chanxian')" style="width: 50%;" clearable>
              <el-option v-for="item in equipmentData" :key="item.id" :label="item.sn + '/' + item.name" :value="item.id" />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('chanpinmingcheng')" required>
            <yi_data_select :multiple="false" :type="'material2'" :ids.sync="yt.editObj.materialId" clearable></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('shengchangongdanhao')" required>
            <el-select v-model="yt.editObj.woIdList" style="width: 50%;" multiple clearable :disabled="woFlag" @change="woListChange">
              <el-option v-for="wo in woList" :key="wo.id" :label="wo.no" :value="wo.id" />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('biaozhungongshi')">
            <el-input v-model="yt.editObj.workHours" style="width: 50%;" disabled />
          </el-form-item>

          <el-form-item :label="$t('jihuashuliang')">
            <el-input v-model="yt.editObj.planQty" style="width: 50%;" disabled />
          </el-form-item>

          <el-form-item :label="$t('shangjishijian')" required>
            <el-date-picker v-model="yt.editObj.upTime" type="datetime" placeholder="" clearable @change="timeChange" />
          </el-form-item>

          <el-form-item :label="$t('xiajishijian')" required>
            <el-date-picker v-model="yt.editObj.downTime" type="datetime" placeholder="" clearable />
          </el-form-item>

          <el-table :data="records" style="width: 100%; margin-top: 20px" border size="mini">
            <el-table-column type="index" width="50" :label="$t('xuhao')" />
            <el-table-column :label="$t('gongwei')" align="center">
              <template slot-scope="scope">
                <yi_dictionary_select type="SILK_SCREEN_PRINTING_STATION" :ids.sync="scope.row.station"></yi_dictionary_select>
              </template>
            </el-table-column>
            <el-table-column :label="$t('renyuan')" align="center">
              <template slot-scope="scope">
                <el-select v-model="scope.row.person" :placeholder="$t('qingxuanze')" size="mini" multiple filterable>
                  <el-option v-for="employ in employList" :key="employ.id" :label="employ.name" :value="employ.id" clearable />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column :label="$t('caozuo')" align="center">
              <template slot-scope="scope">
                <el-button type="text" style="color: red;" @click="removeRecord(scope.$index)">
                  {{ $t('shanchu') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div style="margin: 10px 0;">
            <el-link type="primary" @click="addRecord">+ {{ $t('xinzengyitiaojilu') }}</el-link>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close()">{{ $t('quxiao') }}</el-button>
          <el-button v-if="yt.editObj.action == 'bianji'" size="mini" :loading="yt.editObj.loading" @click="updateData()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'screen_printing_management_staff_allocation',
  data() {
    return {
      workHours: 0,
      rules: {},
      employList: [],
      woFlag: true,
      woList: [],
      equipmentData: [],
      columns: [
        {
          label: 'chanxian',
          prop: 'equipment.name',
          width: 80
        },
        {
          label: 'chanpin',
          prop: 'material.name',
          width: 200
        },
        {
          label: 'gongdan',
          prop: 'no',
          width: 220
        },
        {
          label: 'biaozhungongshi',
          prop: 'workHours',
          width: 120
        },
        {
          label: 'shangjishijian',
          prop: 'upTime',
          type: 'time',
          width: 160
        },
        {
          label: 'xiajishijian',
          type: 'time',
          prop: 'downTime',
          width: 160
        },
        {
          label: 'gongwei',
          type: 'header',
          subCols: [],
          width: 800
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 160,
          fixed: 'right'
        }
      ],
      records: []
    };
  },
  methods: {
    updateData() {
      let params = this.yt.editObj;
      params.records = this.records;

      if (!params.equipmentId) {
        this.utils.errorMessage('产线不能为空');
        return;
      }

      if (!params.materialId) {
        this.utils.errorMessage('产品不能为空');
        return;
      }

      if (!params.woIdList || params.woIdList.length == 0) {
        this.utils.errorMessage('请选择生产工单');
        return;
      }

      if (!params.upTime || !params.upTime) {
        this.utils.errorMessage('上下机时间不能为空');
        return;
      }

      if (!params.records || params.records.length == 0) {
        this.utils.errorMessage('至少有一条明细');
        return;
      }

      if (this.hasDuplicateByProperty(params.records, 'station')) {
        this.utils.errorMessage('工序不能重复');
        return;
      }

      this.yt.editObj.loading = true;
      this.http
        .post('/web/staffing/info/update', params)
        .then(() => {
          this.utils.successMessage(this.$t('chenggong'));
          this.yt.get(1);
        })
        .catch(err => {
          this.utils.errorMessage(this.$t(err));
        })
        .finally(() => {
          this.close();
        });
    },

    hasDuplicateByProperty(arr, prop) {
      const values = arr.map(item => item[prop]);
      return new Set(values).size !== values.length;
    },
    timeChange() {
      console.log(this.yt.editObj.upTime);
      let upTime = this.yt.editObj.upTime.getTime();
      this.$set(this.yt.editObj, 'downTime', upTime + this.workHours);
    },
    getWorkHours() {
      this.http
        .get('/web/staffing/info/workHours', {
          params: {
            woIdList: this.yt.editObj.woIdList
          }
        })
        .then(res => {
          let workHours = res.data.workHours;
          let planQty = res.data.planQty;
          this.$set(this.yt.editObj, 'planQty', planQty);
          this.$set(this.yt.editObj, 'workHours', (workHours / (1000 * 3600)).toFixed(2));
        });
    },
    close() {
      this.yt.isShowEditDialog = false;
      this.yt.editObj.loading = false;
    },
    beforeEdit(params) {
      this.records = params.records;
      return params;
    },
    saveData() {
      let params = this.yt.editObj;
      params.records = this.records;
      if (!params.equipmentId) {
        this.utils.errorMessage('产线不能为空');
        return;
      }

      if (!params.materialId) {
        this.utils.errorMessage('产品不能为空');
        return;
      }

      if (!params.woIdList || params.woIdList.length == 0) {
        this.utils.errorMessage('请选择生产工单');
        return;
      }

      if (!params.upTime || !params.upTime) {
        this.utils.errorMessage('上下机时间不能为空');
        return;
      }

      if (!params.records || params.records.length == 0) {
        this.utils.errorMessage('至少有一条明细');
        return;
      }

      if (this.hasDuplicateByProperty(params.records, 'station')) {
        this.utils.errorMessage('工序不能重复');
        return;
      }

      this.yt.editObj.loading = true;
      this.http
        .post('/web/staffing/info/create', params)
        .then(() => {
          this.utils.successMessage(this.$t('chenggong'));
          this.yt.get(1);
        })
        .catch(err => {
          this.utils.errorMessage(this.$t(err));
        })
        .finally(() => {
          this.close();
        });
    },
    queryEmploy() {
      this.http
        .get('/web/employee/page?pageNum=1&pageSize=9999&orgCode=well05&dtStatus=1')
        .then(res => {
          res.data.rows.forEach(employ => {
            this.employList.push({
              id: employ.id + '',
              name: employ.name
            });
          });
          //  this.employList = res.data.rows;
        })
        .catch(err => {
          this.utils.errorMessage(this.$t(err));
        });
    },
    queryWo(params) {
      this.http
        .get('/custom/weier/process/wo/page?pageNum=1&pageSize=10', {
          params: {
            ...params,
            manufacturingProcessList: ['03', '02', '04'],
            statusList: ['2', '3', '4']
          }
        })
        .then(res => {
          this.woList = res.data.rows;
        });
    },
    queryEquipment() {
      this.http.get('/web/equipment/standing_book/page?pageNum=1&pageSize=9999&orderBy=sort&typeId=10').then(res => {
        this.equipmentData = res.data.rows;
      });
    },
    addRecord() {
      this.records.push({ station: '', person: '' });
    },
    removeRecord(index) {
      this.records.splice(index, 1);
    }
  },
  computed: {
    multiFiled() {
      let equipmentId = this.yt.editObj.equipmentId;
      let materialId = this.yt.editObj.materialId;
      return { equipmentId, materialId };
    },
    woIdList() {
      return this.yt.editObj.woIdList;
    }
  },
  watch: {
    multiFiled: function(val) {
      if (val.equipmentId && val.materialId) {
        this.queryWo(val);
        this.woFlag = false;
      } else {
        this.woFlag = true;
      }
    },
    woIdList: function(val) {
      console.log(val.length);
      if (val && val.length > 0) {
        this.getWorkHours();
      } else {
        this.yt.editObj.workHours = 0.0;
      }
    }
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
    this.queryEquipment();
    this.queryWo();
    this.queryEmploy();
    let dictMap = this.store.state.dictJsonAll['SILK_SCREEN_PRINTING_STATION'];
    let comlumnsTmp = this.utils.copy(this.columns);
    let subCols = [];
    Object.keys(dictMap).forEach(key => {
      subCols.push({ label: dictMap[key], prop: 'subCols.' + key + '', width: 80 });
    });
    for (let index = 0; index < comlumnsTmp.length; index++) {
      const element = comlumnsTmp[index];
      if (element.label == 'gongwei') {
        comlumnsTmp[index].subCols = subCols;
        this.columns = comlumnsTmp;
        break;
      }
    }
  }
};
</script>

<style scoped>
.detail-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.index {
  width: 30px;
  text-align: center;
}
.field {
  flex: 1;
  margin-right: 10px;
}
.remove-btn {
  color: red;
  font-size: 14px;
  padding: 0;
  min-width: auto;
}
</style>
